/**
 * Local Firebase Emulator Suite wiring (multi-device simulation, `npm run sim:devices`).
 *
 * Off unless the bundle was built with REACT_APP_USE_EMULATORS=true, so production builds
 * never touch it. Imported first in index.js: Firestore and Auth must be pointed at the
 * emulators before any other module reads or writes through them.
 */
import { getApps, initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, signInWithEmailAndPassword } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { firebaseConfigWeb } from './firebaseProjectConfig';

export const USE_EMULATORS = process.env.REACT_APP_USE_EMULATORS === 'true';

if (USE_EMULATORS) {
  const host = process.env.REACT_APP_EMULATOR_HOST || '127.0.0.1';
  // The simulator can route one client through a latency proxy by setting this before the app loads
  let simPort = null;
  try { simPort = Number(localStorage.getItem('padelmvp_sim_firestore_port')) || null; } catch (_) {}
  const firestorePort = simPort || Number(process.env.REACT_APP_FIRESTORE_EMULATOR_PORT || 8080);
  const authPort = Number(process.env.REACT_APP_AUTH_EMULATOR_PORT || 9099);

  const app = getApps()[0] || initializeApp(firebaseConfigWeb);
  const auth = getAuth(app);
  connectAuthEmulator(auth, `http://${host}:${authPort}`, { disableWarnings: true });
  connectFirestoreEmulator(getFirestore(app), host, firestorePort);

  // Test-only sign-in hook for the simulator; the auth emulator holds no real accounts.
  window.__padelSim = {
    signIn: (email, password) => signInWithEmailAndPassword(auth, email, password).then((c) => c.user.uid),
  };
  console.warn(`[PadelMVP] Using Firebase emulators at ${host} (firestore:${firestorePort}, auth:${authPort})`);
}
